import React, { useEffect, useState } from 'react';

import { handleAxiosError } from 'core/notifications';

import axios from '@/util/axios';

import getAxiosConfig from '../helpers/getAxiosConfig';

import VideoAgenda from './videoAgenda';

import styles from '../styles/videoVersioningAgenda.module.scss';

const VideoVersioningAgenda = ({ id }) => {
  const [agendaItems, setAgendaItems] = useState([]);

  useEffect(() => {
    const fetchAgendaItems = async () => {
      try {
        setAgendaItems((await axios(getAxiosConfig('get-agenda-items', { id }))).data.data);
      } catch (error) {
        handleAxiosError(error);
      }
    };

    fetchAgendaItems();
  }, [id]);

  return (
    <div className={styles.element}>
      <VideoAgenda agendaItems={agendaItems} />
    </div>
  );
};

export default React.memo(VideoVersioningAgenda);
